
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.232 9.483V3.369a.575.575 0 00-.062-.253c.022-.062.062-.117.062-.186a.586.586 0 00-.425-.564L9.604.022a.59.59 0 00-.321 0L1.079 2.366a.586.586 0 000 1.127l3.09.883v.694c0 .666.371 1.28.944 1.56 2.626 1.292 6.033 1.291 8.66.001.574-.281.944-.894.944-1.561v-.694l2.344-.67v5.777a1.755 1.755 0 00-1.172 1.65v1.172c0 .324.262.586.586.586h2.343a.585.585 0 00.586-.586v-1.172c0-.763-.491-1.407-1.172-1.65z"}}),_c('path',{attrs:{"d":"M14.232 7.761a11.04 11.04 0 01-4.847 1.106c-1.698 0-3.374-.382-4.848-1.106-.144-.071-.263-.176-.39-.27.124 2.11 1.26 3.9 2.863 4.816 0 0 .822.389 1.08.462v-.002c.416.119.845.202 1.295.202.412 0 .999-.082 1.585-.299.27-.096.788-.362.788-.362 1.605-.916 2.74-2.706 2.866-4.816-.129.094-.248.198-.393.27zM9.385 14.14c-.472 0-.927-.072-1.37-.18l1.37 2.056 1.362-2.053c-.44.106-.892.178-1.362.178zM12.758 13.09c-.01.007-.022.012-.033.019l-.493.739c0 .027-2.246 3.387-2.261 3.41V20h7.617a.586.586 0 00.586-.586c0-3.2-2.355-5.826-5.416-6.324zm1.314 4.566H12.9a.586.586 0 110-1.171h1.172a.586.586 0 110 1.171zM6.034 13.102l-.03-.018c-3.058.502-5.408 3.132-5.408 6.33 0 .324.262.586.586.586h7.617v-2.742c-2.656-3.99-2.114-3.176-2.765-4.156z"}})])
          )
        }
      }
    